<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Danh sách hạn mức phòng ban</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="row filter_form">
        <div class="col-md-3">
          <div class="form-group">
            <el-select
              v-model="queryFilter.department"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn phòng ban"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in departments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
      </div>

      <div class="table-responsive mt-4">
        <table class="table table-vertical-center table-bordered mb-0 quota-table">
          <thead class="bg-light">
            <tr>
              <th class="text-left align-middle quota-stt">STT</th>
              <th class="text-left align-middle quota-name-column">Tên phòng ban</th>
              <th class="text-left align-middle quota-value-column">Hạn mức</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="quotaList?.length > 0">
              <tr v-for="(item, index) of quotaList" :key="item?.id">
                <td class="text-left align-middle">{{ (page - 1) * 20 + index + 1 }}</td>
                <td class="text-left align-middle">
                  <p class="line-clamp-1 mb-0 text-break">{{ item.name }}</p>
                </td>
                <td class="align-middle">
                  <div class="d-flex align-items-center quota-edit-wrap">
                    <money
                      v-model="item.quota"
                      v-bind="money"
                      class="form-control text-right quota-input mr-2"
                      @input="handleQuotaInput(item)"
                    />

                    <template v-if="item.change_quota">
                      <button
                        class="btn btn-primary btn-sm font-weight-bold"
                        :disabled="item.saving_quota"
                        @click="saveQuota(item)"
                      >
                        <i :class="item.saving_quota ? 'fas fa-spinner fa-spin mr-1' : 'ki ki-check icon-sm mr-1'"></i>
                        {{ item.saving_quota ? "Đang lưu..." : "Lưu" }}
                      </button>
                      <button
                        class="btn btn-secondary btn-sm font-weight-bold ml-2"
                        :disabled="item.saving_quota"
                        @click="cancelEditQuota(item)"
                      >
                        Hủy
                      </button>
                    </template>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="3" class="text-center">Chưa có dữ liệu</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="quotaList?.length > 0">
          <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
            <paginate
              v-model="page"
              :page-count="lastPage"
              :page-range="3"
              :margin-pages="1"
              :click-handler="clickCallback"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
            />
          </div>
          <div class="d-flex justify-content-end">
            <div>
              Tổng số bản ghi:
              <span class="ml-1 text-primary font-weight-bold">
                {{ this.total ?? quotaList.length }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_DEPARTMENT_QUOTAS, UPDATE_DEPARTMENT_QUOTA } from "@/core/services/store/logistics/logistics.module";
import { GET_DEPARTMENTS } from "@/core/services/store/ticket/ticket.module";
import { Money } from "v-money";

export default {
  name: "QuotaManagement",
  components: {
    Money,
  },
  data() {
    return {
      loading: true,
      page: 1,
      lastPage: 1,
      total: 0,
      quotaList: [],
      departments: [],
      searchQuery: "",
      queryFilter: {
        department: null,
      },
      money: {
        decimal: ",",
        thousands: ",",
        prefix: "",
        suffix: " đ",
        precision: 0,
        masked: false,
      },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Logistics", route: "" },
      { title: "Quản lý hạn mức" },
    ]);
    this.getQuotaList();
    this.getDepartments();
  },
  methods: {
    async handleChangeFilter() {
      this.page = 1;
      await this.getQuotaList();
    },
    clickCallback(obj) {
      this.page = obj;
      this.getQuotaList();
    },
    getDepartments() {
      const payload = { limit: 10000 };
      this.$store.dispatch(GET_DEPARTMENTS, payload).then((res) => {
        if (!res.error) {
          this.departments = res.data ?? [];
        }
      }).catch((e) => {
        console.log(e, "Error get departments");
      });
    },
    async getQuotaList() {
      this.loading = true;
      const payload = {
        page: this.page,
        limit: 20,
        department_id: this.queryFilter.department,
        search: this.searchQuery,
      };

      this.$store.dispatch(GET_DEPARTMENT_QUOTAS, payload).then((res) => {
        if (!res.error) {
          this.page = res.pagination.current_page;
          this.lastPage = res.pagination.last_page;
          this.total = res.pagination.total;
          this.quotaList = (res.data ?? []).map((item) => ({
            ...item,
            quota: Number(item.quota) || 0,
            change_quota: false,
            saving_quota: false,
            original_quota: Number(item.quota) || 0,
          }));
        }
      }).catch((e) => {
        console.log(e, "Error get quota list");
      }).finally(() => {
        this.loading = false;
      });
    },
    handleQuotaInput(item) {
      if ((Number(item.quota) || 0) > 100000000) {
        item.quota = 100000000;
      }
      item.change_quota = Number(item.quota) !== Number(item.original_quota);
    },
    cancelEditQuota(item) {
      item.quota = Number(item.original_quota) || 0;
      item.change_quota = false;
    },
    async saveQuota(item) {
      if (item.saving_quota) return;
      const payload = {
        department_id: item.id,
        quota: Math.min(Number(item.quota) || 0, 100000000),
      };

      item.saving_quota = true;
      this.$store.dispatch(UPDATE_DEPARTMENT_QUOTA, payload).then((res) => {
        if (!res.error) {
          item.change_quota = false;
          item.original_quota = Number(item.quota) || 0;
          this.$bvToast.toast("Cập nhật hạn mức thành công", {
            title: "Thành công",
            variant: "success",
            solid: true,
          });
        }
      }).catch((e) => {
        console.log(e, "Error update quota");
        this.$bvToast.toast("Cập nhật hạn mức thất bại", {
          title: "Lỗi",
          variant: "danger",
          solid: true,
        });
      }).finally(() => {
        item.saving_quota = false;
      });
    },
  },
};
</script>

<style scoped>
.quota-table {
  table-layout: fixed;
  width: 100%;
}

.quota-stt {
  width: 90px;
}

.quota-name-column {
  width: 48%;
}

.quota-value-column {
  width: 42%;
}

.quota-edit-wrap {
  min-height: 38px;
}

.quota-input {
  width: 150px;
  min-width: 150px;
}

.filter_form {
  margin-top: 4px;
}

.filter_form .form-group {
  margin-bottom: 16px;
}

@media screen and (max-width: 767px) {
  .filter_form .form-group {
    margin-bottom: 12px;
  }
}
</style>
